import { Component } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
    'selector': 'app-crmContacts',
    'templateUrl': './crmContacts.page.html',
    'styleUrls': ['./crmContacts.page.scss'],
    'standalone': true,
    'imports': [IonicModule, CommonModule, FormsModule]
})
export class CrmContactsPage {

    // constructor() { }

}
